export const uk = {
    'loading-text': 'Загрузка...'
};
